import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./About";
import Homepage from "./Homepage";
import Portfolio from "./Portfolio";
import Service from "./Service";
import Nav from "./Nav";
import Contact from "./Contact";
import Blog from "./Blog";
import Footer from "./footer";

// import SplashScreen from "./SplashScreen";

export default function App() {
  return (
    <>
      <div className="body">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Nav />}>
              <Route path="/" index element={<Homepage />} />
              <Route path="About" element={<About />} />
              <Route path="Portfolio" element={<Portfolio />} />
              <Route path="Blog" element={<Blog />} />
              <Route path="Service" element={<Service />} />
              <Route path="Contact" element={<Contact />} />
            </Route>
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
